import { useCallback } from 'react'

import { selectFeatureTimezone } from '@/redux/global-selector'
import { useAppSelector } from '@/redux/utils'
import {
  formatTime,
  FormatTimeParams,
} from '@/utils/formatter'


export const useFormatTime = () => {
  const { featureTimezoneName } = useAppSelector(selectFeatureTimezone)
  return useCallback((params?: FormatTimeParams) => {
    return formatTime({ timezone: featureTimezoneName, ...params })
  }, [featureTimezoneName])
}
